import { Button, ButtonGroup, HStack } from "@chakra-ui/react";
import { PriceMode } from "./schema";

const TicketTypeButtons = ({
  priceMode,
  onSelect,
  loading = false,
}: {
  onSelect: (mode: PriceMode) => void;
  loading: boolean;
  priceMode: PriceMode;
}) => {
  return (
    <HStack>
      <ButtonGroup spacing={0} border={"1px"}>
        <Button
          h="40px"
          rounded={"none"}
          _hover={{
            backgroundColor: priceMode === "single" ? "gray.800" : "gray.200",
          }}
          bg={priceMode === "single" ? "black" : "white"}
          disabled={loading}
          color={priceMode === "single" ? "white" : "black"}
          onClick={() => onSelect(PriceMode.SINGLE)}
        >
          Basic
        </Button>
        <Button
          h="40px"
          rounded={"none"}
          disabled={loading}
          _hover={{
            backgroundColor:
              priceMode === "tiered_allocation" ? "gray.800" : "gray.200",
          }}
          bg={priceMode === "tiered_allocation" ? "black" : "white"}
          color={priceMode === "tiered_allocation" ? "white" : "black"}
          onClick={() => onSelect(PriceMode.TIERED_ALLOCATION)}
        >
          Tiered
        </Button>
      </ButtonGroup>
    </HStack>
  );
};

export default TicketTypeButtons;
